import aiStudioService from "@apis/aiStudioService";
import { useAppSelector } from "@hooks/redux";
import { useState } from "react";
import { useDebounce } from "@hooks/utils";

export const useVideoScript = () => {
  const [hasPurchased, setHasPurchased] = useState(false);
  const { language: _language, userInfo } = useAppSelector((state) => state.globalReducer);
  const [status, setStatus] = useState<Status>("idle");
  const [_error, _setErr] = useState<any>(null);

  const checkAiUseCore = async (videoId: string) => {
    setStatus("loading");

    const videoScriptKey = `${userInfo?.username}_videoInsight_${videoId}`;
    const historyData: any = sessionStorage.getItem(videoScriptKey);
    if (historyData) {
      setHasPurchased(Boolean(JSON.parse(historyData).used));
      setStatus("succeeded");
      return;
    }

    const scriptResult: any = await aiStudioService.fetchCheckAiUse({ id: videoId || "", type: "videoScript" });
    // 处理结果
    if (scriptResult) {
      setHasPurchased(Boolean(scriptResult.used));
      if (scriptResult.used) {
        sessionStorage.setItem(videoScriptKey, JSON.stringify(scriptResult));
      }
    }

    setStatus("succeeded");
  };

  const checkAiUse = useDebounce(checkAiUseCore, 200);

  return {
    hasPurchased,
    checkAiUse,
    status,
  };
};
